module.exports = __webpack_public_path__ + "static/media/windsock.27949374.svg";